import React, {useState, useEffect} from "react";

const Timer = () => {
    const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes in seconds

    useEffect(() => {
        if (timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
        <div className={'notification-banner'}>
            <div>
                <b className={'timer'}>{formatTime(timeLeft)}</b>
                There is high demand in your area, please place your order within 30 minutes to confirm your slot.
            </div>
            <i className={'fa  fa-clock-o icon'}/>
        </div>
    );
};

export default Timer;
